<template>
  <el-col v-if="buttonList!=null&&buttonList.length>0" :span="24" class="toolbar" style="padding-bottom: 0px;">
    <el-form :inline="true" @submit.native.prevent>
      <el-form-item label="线路" prop="busLinesId" label-width="60px">
        <el-select style="width: 180px;" @change="selectBusLinesIdChanged" v-model="busLinesId" filterable clearable
          placeholder="请选择线路">
          <el-option v-for="item in busLinesList" :key="item.Id" :value="item.Id" :label="item.LineChineseName">
            <span style="float: left">{{ item.LineChineseName }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发车模版" prop="schedulingTemplateId" label-width="80px">
        <el-select style="width: 180px;" v-model="schedulingTemplateId" clearable placeholder="请选择发车模版">
          <el-option v-for="item in schedulingTemplateList" :key="item.Id" :value="item.Id"
            :label="item.DepartureTemplate">
            <span style="float: left">{{ item.DepartureTemplate }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="司机" prop="driverId" label-width="60px">
        <el-select style="width: 180px;" v-model="driverId" filterable clearable placeholder="请选择司机">
          <el-option v-for="item in driverList" :key="item.Id" :value="item.Id" :label="item.Name">
            <span style="float: left">{{ item.Name }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="车辆" prop="vehicleId" label-width="60px">
        <el-select style="width: 180px;" v-model="vehicleId" filterable clearable placeholder="请选择车辆">
          <el-option v-for="item in vehicleList" :key="item.Id" :value="item.Id" :label="item.LicensePlateNumber">
            <span style="float: left">{{ item.LicensePlateNumber }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button
          :type="item.Func&&(item.Func.toLowerCase().indexOf('handledel')!= -1 ||item.Func.toLowerCase().indexOf('stop')!= -1 )? 'danger':'primary'"
          v-if="!item.IsHide" @click="callFunc(item)">{{item.name}}</el-button>
      </el-form-item>
    </el-form>
  </el-col>
</template>
<script>
import { getBusLinesListPage, getDriverListPage, getVehiclesListPage, getSchedulingTemplateListPage } from "../../api/api";

export default {
  name: "SchedulingBasisToolbar",
  data() {
    return {
      busLinesList: [], //线路列表
      driverList: [], //驾驶员列表
      vehicleList: [], //车辆列表
      schedulingTemplateList: [], //排班模版列表
      busLinesId:"", //线路ID
      driverId:"", //驾驶员Id
      vehicleId:"", //驾驶员Id
      schedulingTemplateId: "", //排班模版表Id
    };
  },
  props: ["buttonList"], //接受父组件传值
  methods: {
    callFunc(item) {
      item.busLinesId = this.busLinesId;
      item.driverId = this.driverId;
      item.vehicleId = this.vehicleId;
      item.schedulingTemplateId = this.schedulingTemplateId;
      this.$emit("callFunction", item); //将值传给父组件
    },
    selectBusLinesIdChanged(value) {
      this.schedulingTemplateList = [];
      this.schedulingTemplateId = "";
      if (value !== "") {
        this.getSchedulingTemplateList();
      }
    },
    getSchedulingTemplateList() {
      let para = {
        busLinesId: this.busLinesId
      };
      getSchedulingTemplateListPage(para).then(res => {
        this.schedulingTemplateList = res.data.response.data;
      });
    }
  },
  mounted() {
    
    let pageSizePara = {
      pageSize: 100
    };
    getBusLinesListPage(pageSizePara).then(res => {
      this.busLinesList = res.data.response.data;
    });

    let page = 1;
    let pageSize = 200;

    let driverPara = {
        companyId: "",
        driverName: "",
        employmentStatus: "",
        page: page,
        pageSize: pageSize
      };
    getDriverListPage(driverPara).then(res => {
       this.driverList = res.data.response.data;
    });

    let vehiclesPara = {
        companyId: '',
        busLinesId: '',
        licensePlateNumber: '',
        terminalsId: '',
        simId: '',
        page: page,
        pageSize: pageSize
      };
    getVehiclesListPage(vehiclesPara).then(res => {
      this.vehicleList = res.data.response.data;
    });
  }
};
</script>